import React  from 'react';
import ArchivoAsociado from './ArchivoAsociado/ArchivoAsociado';
import Ejecucion from './Ejecucion';
import Proceso from './Proceso';

const Formulario = (props) => {
    
    return (
        <form id="bloqueoCrearProducto" name="bloqueoCrearProducto" className="" method="POST">
        <div className="container-fluid tarjetas">
            <Proceso data={props.data} setCheck={props.setCheck}  />      
            <ArchivoAsociado data={props.data} 
                             checkArchivosAsociados={props.checkArchivosAsociados}
                             setNombreArchivo={props.setNombreArchivo}
                             setOptionFormatoArchivo={props.setOptionFormatoArchivo}
                             setRadioButton={props.setRadioButton}/>
            <Ejecucion  data={props.data} 
                        changeInput={props.changeInput} 
                        selectRadio={props.selectRadio}
                        setCheck={props.setCheck}
                        seleccionarCombo={props.seleccionarCombo}
                        />                
        </div>
          
    </form>
)
};

export default Formulario;